module.exports = __webpack_public_path__ + "img/example-cafeteria-menu-2-fr.ed954b8e.webp";